import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Link, useNavigate } from 'react-router-dom';

const LoginForm = () => {

  console.log("🔥 THIS IS THE REAL LoginForm.js at " + __filename);
  const API_PREFIX = '/api';
  const { theme } = useTheme();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    console.log('Starting login attempt');
      
    try {
      const testResponse = await fetch(API_PREFIX + '/auth/test-cookie', {
        credentials: 'include'
      });
      console.log('Test connection response:', testResponse.status);
      
        console.log('Sending login request');
        console.log("ENV VAR:", process.env.REACT_APP_API_PREFIX);
        console.log("API_PREFIX:", API_PREFIX);
        console.log("Requesting URL:", API_PREFIX + '/auth/login');
        const response = await fetch(API_PREFIX + '/auth/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify(formData)
        });
  
      console.log('Got response:', response.status);
      const data = await response.json();
      console.log('Response data:', data);
  
      if (!response.ok) {
        if (response.status === 403) {
          setError("Email not verified. Check your email or resend verification.");
          return;
        }
        throw new Error(data.detail || 'Login failed');
      }
  
      console.log('Login successful, storing user data');
      localStorage.setItem('user', JSON.stringify(data.user));
      
      console.log('About to navigate');
      if (window.location.pathname.includes('/dev')) {
        window.location.href = '/dev/notes';
      } else {
        window.location.href = '/notes';
      }

      
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message);
    }
};

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label 
          htmlFor="email" 
          className="block text-sm font-medium mb-2"
          style={{ color: theme.mainPanelText }}
        >
          Email address
        </label>
        <input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
          style={{ 
            backgroundColor: theme.inputBg,
            borderColor: theme.inputBorder,
            color: theme.inputText
          }}
          required
        />
      </div>

      <div>
        <label 
          htmlFor="password" 
          className="block text-sm font-medium mb-2"
          style={{ color: theme.mainPanelText }}
        >
          Password
        </label>
        <input
          id="password"
          name="password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
          style={{ 
            backgroundColor: theme.inputBg,
            borderColor: theme.inputBorder,
            color: theme.inputText
          }}
          required
        />
      </div>

      {error && (
        <div className="text-red-500 text-sm">{error}</div>
      )}

      <button
        type="submit"
        className="w-full py-2 px-4 rounded-md font-medium focus:outline-none focus:ring-2 transition duration-150"
        style={{
          backgroundColor: theme.buttonBg,
          color: theme.buttonText,
        }}
      >
        Sign In
      </button>

      <div className="mt-4 text-center">
        <span style={{ color: theme.mainPanelText }}>
          Don't have an account?{' '}
        </span>
        <Link 
          to="/signup" 
          className="font-medium"
          style={{ color: theme.accentColor }}
        >
          Sign Up
        </Link>
        <div className="mt-4 text-center">
            <Link 
              to="/forgot-password" 
              className="font-medium"
              style={{ color: theme.accentColor }}
            >
              Forgot Password?
            </Link>
          </div>
      </div>
    </form>
  );
};

export default LoginForm;